module.exports = __webpack_public_path__ + "img/Boundaries_fbvrbz_c_scale,w_1047.57983ad7.jpg";